import { Component, ChangeDetectionStrategy } from '@angular/core';

import { ActivatedRoute, RouterModule } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'no-membership',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './no-membership.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./no-membership.component.scss'],
})
export class NoMembershipComponent {
  status: number | null = null;
  code: string | null = null;
  message: string | null = null;
  noShow = true;
  loading!: boolean;

  constructor(
    private route: ActivatedRoute,
    public authService: AuthService
  ) {
    const s = history.state as any;

    this.code = s?.code ?? s?.Code ?? null;
    this.message = s?.message ?? s?.Message ?? null;

    this.route.queryParamMap.subscribe((params) => {
      this.status = params.get('status') ? Number(params.get('status')) : null;
    });
  }

  logout() {
    this.authService.logout();
  }
}
